const INVALID_ERP_DATE_PATTERN = /^0001-01-01/;

const isValidDateParts = (
  year: number,
  month: number,
  day: number
): boolean => {
  if (
    !Number.isInteger(year) ||
    !Number.isInteger(month) ||
    !Number.isInteger(day) ||
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31
  ) {
    return false;
  }

  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
};

const formatYYYYMMDD = (year: number, month: number, day: number): string =>
  `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

/**
 * Normalizes a birth date from UI/API/OCR sources to the backend payload format.
 * Accepts DD/MM/YYYY for UI state and YYYY-MM-DD or ISO datetimes from APIs.
 */
export const normalizeBirthDateToBackendDate = (
  value?: string | null
): string | undefined => {
  const normalized = value?.trim();
  if (!normalized || INVALID_ERP_DATE_PATTERN.test(normalized)) {
    return undefined;
  }

  const isoMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const year = parseInt(isoMatch[1], 10);
    const month = parseInt(isoMatch[2], 10);
    const day = parseInt(isoMatch[3], 10);

    return isValidDateParts(year, month, day)
      ? formatYYYYMMDD(year, month, day)
      : undefined;
  }

  const brMatch = normalized.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (brMatch) {
    const day = parseInt(brMatch[1], 10);
    const month = parseInt(brMatch[2], 10);
    const year = parseInt(brMatch[3], 10);

    return isValidDateParts(year, month, day)
      ? formatYYYYMMDD(year, month, day)
      : undefined;
  }

  return undefined;
};

export const normalizeBirthDateToBackendDateTime = (
  value?: string | null
): string | undefined => {
  const backendDate = normalizeBirthDateToBackendDate(value);
  return backendDate ? `${backendDate}T00:00:00` : undefined;
};
